const MAX_COVER_PHOTO_MB = 5;
const MAX_GENERAL_FILE_MB = 20;
const KB = 1024;
export const AppConstants = {
    appName: 'EduScript',
    defaultPageSize: 0,
    defaultRowCount: 10,
    max20MBFile: 20,
    max5MBFile: 5,
    resendTimer: 30,
    encryptionKey: 'ofo2O3Qnk4P9wqqvfzeOZ1Wum8ESGqRTmOxNPbTomDc=\n',
    aesKey: 'ofo2O3Qnk4P9wqqvfzeOZ1Wum8ESGqRTmOxNPbTomDc=\n',
    aesIV: 'QWNce8ESSh0g/FE2ZVV4Fg==\n',
    dateRange: 2,
    totalSegmentCount: 15,
    urlIndexProgramId: 2,
    coverPhotoMaxSize: MAX_COVER_PHOTO_MB * KB * KB, //5MB
    KnowledgeBank_MaxFileUploadSize: MAX_GENERAL_FILE_MB * KB * KB, // 20MB
    allowedFileTypes: [
        '.xls',
        '.xlsx',
        '.doc',
        '.docx',
        '.txt',
        '.ppt',
        '.pptx',
        '.pdf',
    ],
    allowSegmentType: [
        '.jpg',
        '.png',
        '.doc',
        '.docx',
        '.ppt',
        '.xlsx',
        '.xls',
        '.txt',
        '.mp3',
        '.wav',
        '.ogg',
        '.aac',
        '.mp4',
        '.webm',
        '.mov',
    ],
    staticValidations: {
        maxLength: {
            userName: 50,
            name: 150,
            description: 4000,
            aiPrompt: 3000,
            address: 500,
            normalDescription: 500,
            headline: 150,
            storyboard: 4000,
            script: 8000,
            comment: 250,
            common: 250,
            subjectMatrix: 12,
            useCaseMatrix: 12,
            password: [8, 50],
            useCase: 120,
        },
        ekcValue: [0, 1, 2, 3] as const,
        maxFileUploadLimit: 25,
        warningMessageTimeout: 3000,
        intervalTime: 1000,
    },
    awsS3: {
        entity: {
            user: 'user' as const,
            program: 'program' as const,
        },
        subEntity: {
            coverPhoto: 'cover_photo' as const,
            knowledgeBank: 'knowledge_bank' as const,
            segment: 'section_segment' as const,
        },
    },
    multiLingualDateFormat: {
        withTime: {
            '1': 'MM/DD/YYYY hh:mm A',
            '2': 'DD/MM/YYYY HH:mm',
        },
        withoutTime: {
            '1': 'MM/DD/YYYY',
            '2': 'DD/MM/YYYY',
        },
        withoutTimeTwoYear: {
            '1': 'mm/dd/yy',
            '2': 'dd/mm/yy',
        },
    },
    editCourse: 'Edit Course',
    editLesson: 'Edit Lesson',
    editChapter: 'Edit Chapter',
    editSection: 'Edit Section',
};
